
import { NotificationDto } from "../dto/Notification.Dto";
import { Notification } from "../../entity/Notification";
import { toDate } from "../../utils/GlobalFunctions";

export class NotificationMapper {
    static mapFromDto(dto: NotificationDto): Notification {

        return {
            id: dto.id || "",
            title: dto.title,
            message: dto.message,
            isRequired: dto.isRequired,
            url: dto.url,
            type: dto.type,
            createdAt: toDate(dto.createdAt),
            updatedAt: toDate(dto.updatedAt)
        };
    }
}

